export default __webpack_public_path__ + "static/media/IMG_0049_6_11zon.f1fe61ac.jpg";